import { render } from "./PublicInfo.vue?vue&type=template&id=a46a1e28&scoped=true"
import script from "./PublicInfo.vue?vue&type=script&lang=js"
export * from "./PublicInfo.vue?vue&type=script&lang=js"

import "./PublicInfo.vue?vue&type=style&index=0&id=a46a1e28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46a1e28"]])

export default __exports__